import { UsersInterface } from '../../..';

export class IsEmailAvailableDto implements UsersInterface {
  email: string;
}
